import React, { SyntheticEvent } from 'react'
import {
  Button,
  ButtonColorVariant,
  ButtonVariant,
  Color,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'
import type { RecipeUUID } from '@library/menu-service'

const ButtonStyled = withCitrusTheme(Button, (theme) => ({
  '&:disabled, &:disabled:hover, &:disabled:focus': {
    color: theme.color(Color.White),
  },
}))

export const AddRecipeButton: React.FC<{
  recipeUuid: RecipeUUID
  setBrowserCTAVisible: () => void
  canAddRecipes: boolean
  addRecipe: (recipeId: RecipeUUID, view: string, recipeInfo: { position?: number }) => void
  removeRecipe: (recipeId: RecipeUUID) => void
  reachedLimit: boolean
  isInBasket: boolean
  isOutOfStock: boolean
  index?: number
}> = ({
  recipeUuid,
  setBrowserCTAVisible,
  canAddRecipes,
  addRecipe,
  removeRecipe,
  reachedLimit,
  isInBasket,
  isOutOfStock,
  index,
}) => {
  const atLimit = reachedLimit && !isInBasket
  const disabled = isOutOfStock || atLimit

  const buttonAction: React.EventHandler<SyntheticEvent<unknown>> = (e) => {
    e.stopPropagation()

    if (!canAddRecipes) {
      setBrowserCTAVisible()
      return
    }

    if (isInBasket) {
      removeRecipe(recipeUuid)
    } else {
      addRecipe(recipeUuid, 'view_recipe_list_screen', { position: index })
    }
  }

  const buttonKeyPressAction: React.KeyboardEventHandler = (e) => {
    e.stopPropagation()

    if (e.keyCode === 13) {
      buttonAction(e)
    }
  }

  return (
    <ButtonStyled
      variant={ButtonVariant.Icon}
      icon={isInBasket ? 'remove' : 'add'}
      colorVariant={isInBasket ? ButtonColorVariant.Secondary : ButtonColorVariant.Primary}
      disabled={disabled}
      onClick={buttonAction}
      onKeyPress={buttonKeyPressAction}
      data-testing={
        disabled ? 'menuRecipeAddDisabled' : isInBasket ? 'menuRecipeCardRemove' : 'menuRecipeAdd'
      }
      aria-label={isInBasket ? 'Remove recipe' : 'Add recipe'}
    />
  )
}
